// Explicit restrictions per role. Roles NOT listed here retain full access,
// preserving existing behavior. Add entries as new roles are locked down.
//
// Shape:
//   RESTRICTIONS[roleKey] = {
//     editDenied: Set<resourceKey>   // resources this role can view but not edit
//   }
//
// Resource keys align with tab keys used in getuserRoleTabs.js.
const RESTRICTIONS = {
  Clinical_Practitioner: {
    editDenied: new Set([
      "medicine",
      "diet",
      "progress_monitoring",
      "gallery",
      "monitoring-charts",
    ]),
  },
  Physiotherapist: {
    editDenied: new Set(["medicine"]),
  },
  Psychologist: {
    editDenied: new Set(["medicine"]),
  },
  Speech_Swallow_Therapist: {
    editDenied: new Set(["medicine"]),
  },
  Nutritionist: {
    editDenied: new Set(["medicine"]),
  },
  Respiratory_Therapist: {
    editDenied: new Set(["medicine"]),
  },
};

/**
 * Whether `role` may perform `action` on `resource`.
 *
 * Defaults to `true` for any role not present in RESTRICTIONS — this keeps
 * existing role behavior unchanged. Add roles above to lock them down.
 *
 * @param {string} role      Backend role key, e.g. "Doctor", "Clinical_Practitioner"
 * @param {string} action    "view" | "edit" | "create" | "delete"
 * @param {string} resource  Tab or feature key, e.g. "medicine", "review"
 */
export const can = (role, action, resource) => {
  const rules = RESTRICTIONS[role];
  if (!rules) return true;

  if (action === "edit") {
    return !rules.editDenied?.has(resource);
  }

  return true;
};

export const canEdit = (role, resource) => can(role, "edit", resource);
